import { useMutation } from '@apollo/client';
import { UPDATE_OTHER_ITEM, GET_OTHER_ITEMS } from '../graphql';
import {
  UpdateOtherItem,
  UpdateOtherItemVariables,
} from '../graphql-types/UpdateOtherItem';

export const useUpdateOtherItem = () => {
  const [mutate, state] = useMutation<
    UpdateOtherItem,
    UpdateOtherItemVariables
  >(UPDATE_OTHER_ITEM, {
    refetchQueries: [GET_OTHER_ITEMS],
  });

  const updateOtherItem = async (
    input: UpdateOtherItemVariables['input'],
  ) => {
    const { data } = await mutate({
      variables: { input },
    });

    return data?.updateOtherItem;
  };

  return {
    updateOtherItem,
    ...state,
  };
};
